import { getVisitorId } from "@/lib/visitorId";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

/** Safe gtag wrapper — no-ops when the tag is blocked or not yet loaded. */
export function gtagCall(...args: unknown[]): void {
  try {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag(...args);
  } catch (err) {
    console.error("gtag failed:", err);
  }
}

/** Send a SPA page view to GA4 (gtag only auto-tracks the initial load). */
export function gaPageView(path: string): void {
  const visitorId = getVisitorId();
  if (visitorId) gtagCall("set", { user_id: visitorId });
  gtagCall("event", "page_view", {
    page_path: path,
    page_location: typeof window !== "undefined" ? window.location.href : undefined,
    page_title: typeof document !== "undefined" ? document.title : undefined,
  });
}

/** Mirror an app event into GA4 as a custom event. */
export function gaEvent(name: string, params?: Record<string, unknown>): void {
  gtagCall("event", name, params ?? {});
}
